export default function SvgVideo7() {
  return (
    <>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#000"
        width="20px"
        viewBox="0 0 1920 1920"
      >
        <path
          fillRule="evenodd"
          d="M1813.333 1557.195c-557.76 126.826-1148.48 126.826-1706.666 0V468.448c557.76-126.827 1148.48-126.933 1706.666 0v1088.747zM1879.04 374.26c-600.32-143.573-1238.4-143.466-1838.08 0L0 384.075v1257.493l40.96 9.813c300.053 71.787 609.28 108.054 919.04 108.054 309.867 0 619.2-36.267 919.04-108.054l40.96-9.813V384.075l-40.96-9.814zM853.333 786.987l376.32 225.813-376.32 225.813V786.987zm-106.666 640l690.346-414.187-690.346-414.187v828.374z"
        ></path>
      </svg>
  </>
  );
}
